import {UPDATE_CURRENT_LANGUAGE} from "../actions/multiLanguageActions";
const locale = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en';
export default function(state=locale, action){
    switch(action.type){
        case UPDATE_CURRENT_LANGUAGE:
            return action.payload;
        default:
            return state;
    }
}